import { useState } from "react";
import { Label } from "~/components/ui/label.jsx";
import { Input } from "~/components/ui/input.jsx";
import { Checkbox } from "~/components/ui/checkbox.jsx";
import { Link } from "@inertiajs/react";

export default function PersonalDataProcessing({ onChange }) {
  const [accepted, setAccepted] = useState(true);

  const handleChange = (checked) => {
    onChange(checked);
    setAccepted(checked);
  };

  return (
    <div>
      <label className="space-x-2 select-none">
        {/* <input
          type="checkbox"
          className="checkbox"
          checked={accepted}
          onChange={handleChange}
        /> */}
        <div className="flex space-x-2 items-center">
          <Checkbox id="terms-and-conditions" onCheckedChange={handleChange}/>
          <Label htmlFor="terms-and-conditions" className="font-light">
            <span className="input-text">
              Я ознакомился с{" "}
              <Link className="underline" target="_blank" href="/confidential">
                соглашением на обработку персональных данных
              </Link>{" "}
              и принимаю его условия.
            </span>
          </Label>
        </div>
      </label>
    </div>
  );
}
